export class MailingRegisterReport {
    mailingRegisterReportId: number;
    mailingRegisterId: number;

    reportType: number;

    salaryCalcReportId?: number;
    analyticReportId?: number;
    requestToAgreeReportId?: number;
}